import React from "react";
import { Trash } from "react-feather";
import { Button } from "reactstrap";

export const RemoveButton = ({ removeHandler }) => (
  <Button color="link" size="sm" onClick={removeHandler}>
    <Trash color="red" size={20} />
  </Button>
);
